var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoonnow2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177,
    height: 182,
    viewBox: "0 0 177 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 182
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 182,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.476 -114.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 77.556,
    cy: 77.556,
    r: 77.556,
    transform: "translate(82.92 129.065)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.586,34.736A71.994,71.994,0,1,0,107.2,178.12a71.99,71.99,0,0,1-46.656-38.739q.519,1.194,1.08,2.369-.429.038-.86.045a12.179,12.179,0,0,1-6.411-22.541q.216,1.361.483,2.713a69.741,69.741,0,0,1,5.283-43.278,5.771,5.771,0,0,1-3.328-2.634C54.516,71.726,59.3,64.735,67.474,60.441a29.379,29.379,0,0,1,7.156-2.654A71.99,71.99,0,0,1,116.905,37.2a71.991,71.991,0,0,0-18.32-2.461ZM55.969,126.849q.3,1.209.649,2.407-.345-1.2-.649-2.407Zm1.988,6.347q.556,1.569,1.185,3.111-.628-1.541-1.185-3.111Z",
    transform: "translate(61.891 99.894)",
    fill: "#ccc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonnow2);
export default __webpack_public_path__ + "static/media/moonnow2.0afc7641a1128c0e4c036397e3a420db.svg";
export { ForwardRef as ReactComponent };